export default "__VITE_ASSET__DChEz7$s__"